import httpClient from "../config/httpClient";

export class BundleTypeConfigurationsService {
	private static readonly BASE_URL = "/admin/bundle-type-configurations";

	public static list(params?: { page?: number; limit?: number; search?: string }) {
		return httpClient.get(`${this.BASE_URL}`, { params });
	}

	public static create(data: any) {
		return httpClient.post(`${this.BASE_URL}`, data);
	}

	public static update(id: number, data: any) {
		return httpClient.put(`${this.BASE_URL}/${id}`, data);
	}

	public static delete(id: number) {
		return httpClient.delete(`${this.BASE_URL}/${id}`);
	}

	public static getOptions(params: { field: string; limit?: number; isExtra?: boolean; isExtraMobile?: boolean }) {
		return httpClient.get(`${this.BASE_URL}/options`, { params });
	}
}
